import React from 'react'

import './Spinner.css'

const Spinner = () => (
  <div className="Spinner">
    <div className='squares'></div>
  </div>
)

export default Spinner



// WEBPACK FOOTER //
// ./src/components/Spinner/index.js